<template>
<div class="card">
  <div class="card-content">
    <div class="media">
      <div class="media-content">
        <p class="title is-4">{{location}}</p>
        <p class="subtitle is-6">{{date}}</p>
      </div>
    </div>

    <div class="content">
    <p>
    <strong>Facilitated by:</strong>
      {{facilitators}}</p>
    </div>
  </div>
</div>
</template>


<script>
export default {
  name: "Workshop",
  props: {
    location: String,
    date: Date,
    facilitators:String
  }
};
</script>